import axios from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {Odjel} from '../models/Odjel'
import {Skladiste} from '../models/Skladiste'

const API_URL = process.env.REACT_APP_API_URL
const DROPDOWN_API = `${API_URL}/skladisteDropdown`
const API = `${API_URL}/skladiste`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

// Get request for Skladiste Dropdown  data.
export async function getSkladisteDropdown() {
  try {
    return await axios.get<Array<Option>>(DROPDOWN_API, {headers: headers})
  } catch (error) {
    console.error('Error fetching Skladiste Dropdown  data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function getSkladista(pageNo: number, perPage: number) {
  const params = {per_page: perPage, page: pageNo}
  return await axios.get<Array<Odjel>>(API, {headers: headers, params: params})
}
export async function saveSkladiste(Data: any) {
  return await axios.post(API, Data, {headers: headers})
}

export async function fetchSkladiste(Id: number): Promise<Partial<Skladiste>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching Odjel data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateSkladiste(Data: any, id: number) {
  return await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
}

export async function deleteSkladiste(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete Boja.')
    }
  } catch (error) {
    console.error('Error deleting Boja data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
